import { Button, Modal, Radio } from "antd";
import { useState } from "react";

const DEF_ENCODING = 'windows-1251';
const DEF_SEP = "59"; //char code _;_
const DEF_DEC_SEP = ',';

export const ExportModalWindow = ({onExport, onCancel, opened}) => {

    const [ encoding, setEncoding ] = useState(DEF_ENCODING);
    const [ sep, setSep ] = useState(DEF_SEP);    
    const [ decSep, setDecSep ] = useState(DEF_DEC_SEP);

    const [ isOpen, setIsOpen ] = useState(opened);

    const onCancelClick = () => {
        setIsOpen(false);
        onCancel();
    }

    const onEncodingChange = ( e ) => {
        setEncoding( e.target.value );
    }

    const onSepChange = ( e ) => {
        setSep( String.fromCharCode(e.target.value) );
    }

    const onDecSepChange = ( e ) => {
        setDecSep( e.target.value );            
    }


    return (
        <Modal title="Выгрузка данных" open={isOpen} onCancel={onCancelClick}
            footer={[
                <Button key="submit" type="primary" onClick={() => onExport(encoding, sep, decSep)}>
                    Выгрузить
                </Button>
                ]}        
        >
            <div>
                <Radio.Group onChange={onEncodingChange} name="radio-encoding" defaultValue={DEF_ENCODING} className="to-cols">
                    <Radio value="windows-1251">Windows-1251</Radio>
                    <Radio value="UTF-8">UTF-8</Radio>
                </Radio.Group>                            

                <Radio.Group onChange={onSepChange}  name="radio-separator" defaultValue={DEF_SEP} className="to-cols mt-1">
                    <Radio value="59">Разделитель ;</Radio>
                    <Radio value="9">Разделитель TAB</Radio>
                </Radio.Group>    

                <Radio.Group onChange={onDecSepChange}  name="radio-separator" defaultValue={DEF_DEC_SEP} className="to-cols mt-1">
                    <Radio value=",">Десятичная ,</Radio>                    
                    <Radio value=".">Десятичная .</Radio>                    
                </Radio.Group>                            
            </div>
      </Modal>    

    );    
}